import Vue from 'vue'
import VuePackeryPlugin from 'vue-packery-plugin'
import Blog from '../vue/blog.vue'
import Stickyfill from 'stickyfill'
import 'promise-polyfill/src/polyfill';

export default {
  init() {
    // JavaScript to be fired on the home page

    Vue.use(VuePackeryPlugin);
    new Vue({
      el: "#blog-grid",
      components: {
        Blog,
      },
    });

    let stickyElements = document.querySelectorAll('.sticky');

    for (var i = stickyElements.length - 1; i >= 0; i--) {
      Stickyfill.add(stickyElements[i]);
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/post-type-archive-blog.js